import React from 'react';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactSelectMaterialUi from 'react-select-material-ui';
import TabPanelDetail from '../atoms/TabPanelDetail';
import { languages, languageType } from '../../constants/Language';

const styles = {
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: 10,
    fontSize: 12
  },
  userImage: {
    width: '100px',
    height: '100px',
    margin: '5px',
    float: 'left'
  },
  tag: {
    margin: '0px 10px 0px 0px',
    backgroundColor: '#fee'
  },
  anniversary: {
    margin: '0px 10px 0px 0px'
  },
  marginBottom12: {
    marginBottom: '12px'
  },
  root: {
    boxShadow: 'none'
  },
  tabpanelHeader: {
    padding: '0 2px',
    borderBottom: '2px solid #D8EBFF',
    minHeight: 'unset'
  },
  btnTabpanel: {
    padding: '5px 2px',
    backgroundColor: '#F7F7F7',
    borderRadius: '3px 3px 0 0',
    fontSize: 12,
    fontWeight: 600,
    color: '#777777',
    height: 'auto',
    minHeight: 'unset',
    borderTop: '5px solid #ffffff',
    width: '33%',
    minWidth: '100px',

    '&:first-child': {
      marginRight: 2
    },
    '&:last-child': {
      marginLeft: 2
    }
  },
  tabSelected: {
    backgroundColor: '#D8EBFF',
    fontWeight: 'bold',
    color: '#000000 !important',
    borderTopColor: '#D8EBFF'
  },
  tableCell90: {
    width: '90%'
  },
  textField: {
    padding: 0,
    width: '100%'
  },
  langDiv: {
    margin: '0 10px'
  },
  breakLine: {
    whiteSpace: 'pre-line'
  }
};
const propTypes = {
  classes: PropTypes.object.isRequired
};

// const enhance = compose(pure);
const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('shopName', 'setShopName', ''),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefecture', 'setPrefecture', ''),
  withState('city', 'setCity', ''),
  withState('address1', 'setAddress1', ''),
  withState('address2', 'setAddress2', ''),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('introduction', 'setIntroduction', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('access', 'setAccess', ''),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('value', 'setValue', 0),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('haveRegistrationId', 'setHaveRegistrationId', 0),
  withHandlers({}),
  lifecycle({
    componentDidMount() {
      this.props.setShopName(this.props.detail.shopName);
      this.props.setShopNameKana(this.props.detail.shopNameKana);
      this.props.setAddress1(this.props.detail.address1);
      this.props.setAddress2(this.props.detail.address2);
      this.props.setBuilding(this.props.detail.building);
      this.props.setShopGroupName(this.props.detail.shopGroupName);
      this.props.setShopContactName(this.props.detail.shopContactName);
      this.props.setDepartment(this.props.detail.department);
      this.props.setIntroduction(this.props.detail.introduction);
      this.props.setBusinessHours(this.props.detail.businessHours);
      this.props.setHoliday(this.props.detail.holiday);
      this.props.setNearestStation(this.props.detail.nearestStation);
      this.props.setAccess(this.props.detail.access);
      this.props.setNumberSit(this.props.detail.numberSit);
      this.props.setSmoking(this.props.detail.smoking);
      this.props.setParking(this.props.detail.parking);
      this.props.setPrefecture(this.props.detail.prefectures);
      this.props.setCity(this.props.detail.city);

      if (this.props.detail.paymentGroupId) {
        if (this.props.detail.groupRegistrationId) {
          this.props.setHaveRegistrationId(1);
        } else {
          this.props.setHaveRegistrationId(0);
        }
      } else if (this.props.detail.registrationId) {
        this.props.setHaveRegistrationId(1);
      } else {
        this.props.setHaveRegistrationId(0);
      }
    }
  })
);

const ShopTable = enhance(
  ({
    classes,
    detail,
    value,
    setValue,
    isLanguage,
    setIsLanguage,
    shopName,
    setShopName,
    shopNameKana,
    setShopNameKana,
    address1,
    // ddress2,
    setAddress1,
    setAddress2,
    building,
    setBuilding,
    shopGroupName,
    setShopGroupName,
    shopContactName,
    setShopContactName,
    department,
    setDepartment,
    introduction,
    setIntroduction,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    nearestStation,
    setNearestStation,
    access,
    setAccess,
    numberSit,
    setNumberSit,
    smoking,
    setSmoking,
    parking,
    setParking,
    prefecture,
    setPrefecture,
    city,
    setCity,
    isFukuoka,
    haveRegistrationId
  }) => {
    const enableShopBank = detail.bankSwitchable;
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
    const setLanguage = v => {
      const lang = isLanguage;
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        if (
          !detail.otherLanguages ||
          (detail.otherLanguages && detail.otherLanguages.length <= 0)
        ) {
          setShopName('');
          setShopNameKana('');
          setAddress1('');
          setAddress2('');
          setBuilding('');
          setShopGroupName('');
          setShopContactName('');
          setDepartment('');
          setIntroduction('');
          setBusinessHours('');
          setHoliday('');
          setNearestStation('');
          setAccess('');
          setNumberSit('');
          setSmoking('');
          setParking('');
          setPrefecture('');
          setCity();
        }
        // origin to other or other to other lang
        for (let k = 0; k < detail.otherLanguages.length; k += 1) {
          if (detail.otherLanguages[k].language === v) {
            setShopName(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.shopName
                ? detail.otherLanguages[k].params.shopName
                : ''
            );
            setShopNameKana(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.shopNameKana
                ? detail.otherLanguages[k].params.shopNameKana
                : ''
            );
            setAddress1(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.address1
                ? detail.otherLanguages[k].params.address1
                : ''
            );
            setAddress2(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.address2
                ? detail.otherLanguages[k].params.address2
                : ''
            );
            setBuilding(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.building
                ? detail.otherLanguages[k].params.building
                : ''
            );
            setShopGroupName(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.shopGroupName
                ? detail.otherLanguages[k].params.shopGroupName
                : ''
            );
            setShopContactName(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.shopContactName
                ? detail.otherLanguages[k].params.shopContactName
                : ''
            );
            setDepartment(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.department
                ? detail.otherLanguages[k].params.department
                : ''
            );
            setIntroduction(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.introduction
                ? detail.otherLanguages[k].params.introduction
                : ''
            );
            setBusinessHours(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.businessHours
                ? detail.otherLanguages[k].params.businessHours
                : ''
            );
            setHoliday(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.holiday
                ? detail.otherLanguages[k].params.holiday
                : ''
            );
            setNearestStation(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.nearestStation
                ? detail.otherLanguages[k].params.nearestStation
                : ''
            );
            setAccess(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.access
                ? detail.otherLanguages[k].params.access
                : ''
            );
            setNumberSit(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.numberSit
                ? detail.otherLanguages[k].params.numberSit
                : ''
            );
            setSmoking(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.smoking
                ? detail.otherLanguages[k].params.smoking
                : ''
            );
            setParking(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.parking
                ? detail.otherLanguages[k].params.parking
                : ''
            );
            setPrefecture(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.prefectures
                ? detail.otherLanguages[k].params.prefectures
                : ''
            );
            setCity(
              detail.otherLanguages[k].params &&
                detail.otherLanguages[k].params.city
                ? detail.otherLanguages[k].params.city
                : ''
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        // other to origin
        setShopName(detail.shopName);
        setShopNameKana(detail.shopNameKana);
        setAddress1(detail.address1);
        setAddress2(detail.address2);
        setBuilding(detail.building);
        setShopGroupName(detail.shopGroupName);
        setShopContactName(detail.shopContactName);
        setDepartment(detail.department);
        setIntroduction(detail.introduction);
        setBusinessHours(detail.businessHours);
        setHoliday(detail.holiday);
        setNearestStation(detail.nearestStation);
        setAccess(detail.access);
        setNumberSit(detail.numberSit);
        setSmoking(detail.smoking);
        setParking(detail.parking);
        setPrefecture(detail.prefectures);
        setCity(detail.city);
      }
      setIsLanguage(v);
    };

    return (
      <Paper className={classes.root}>
        <div className={classes.langDiv}>
          <ReactSelectMaterialUi
            required
            className={[classes.tableCell90, classes.textField]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              setLanguage(v);
            }}
          />
        </div>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered={!isFukuoka}
          className={classes.tabpanelHeader}
        >
          <Tab
            label="基本情報（必須）"
            className={classNames(
              classes.btnTabpanel,
              value === 0 && classes.tabSelected
            )}
          />
          <Tab
            label="その他（任意）"
            className={classNames(
              classes.btnTabpanel,
              value === 1 && classes.tabSelected
            )}
          />
          {!isFukuoka && (
            <Tab
              label="高度な設定（任意）"
              className={classNames(
                classes.btnTabpanel,
                value === 2 && classes.tabSelected
              )}
            />
          )}
        </Tabs>

        {/* Required 基本情報（必須） */}
        <TabPanelDetail value={value} index={0}>
          <Table className={classes.detailTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  {isFukuoka ? '教室名' : '店舗名'}
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {shopName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  {isFukuoka ? '教室名かな' : '店舗名かな'}
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {shopNameKana}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  郵便番号
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.zipCode}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>住所</TableCell>
                <TableCell className={classes.tableCellData}>
                  {prefecture}
                  {` `}
                  {city}
                  {` `}
                  {address1}
                  {` `}
                  {/* {address2} */}
                  {` `}
                  {building}
                </TableCell>
              </TableRow>

              {!isFukuoka && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    店舗カテゴリー
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.shopCategories &&
                      detail.shopCategories.map(item => {
                        if (
                          detail.shopCategoryId &&
                          detail.shopCategoryId.toString() ===
                            item.id.toString()
                        ) {
                          return item.name;
                        }
                        return '';
                      })}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  運営会社名
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {shopGroupName || 'なし'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  ご担当者名
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {shopContactName || 'なし'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  所属部署
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {department || 'なし'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  電話番号（担当者）
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.contactPhone}
                </TableCell>
              </TableRow>
              {!isFukuoka && !detail.paymentGroupId && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      インボイス制度 適格事業者登録
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {haveRegistrationId ? '登録済み' : '未登録'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      適格事業者登録番号
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {// eslint-disable-next-line no-nested-ternary
                      detail.paymentGroupId
                        ? detail.groupRegistrationId
                        : haveRegistrationId
                        ? detail.registrationId
                        : undefined}
                    </TableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  {isFukuoka ? '教室電話番号' : '店舗電話番号'}
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.phone}
                  {'('}
                  {detail.showPhone ? `表示` : `非表示`}
                  {')'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  メールアドレス
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.email}
                </TableCell>
              </TableRow>

              {enableShopBank && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '振込先' : '入金管理'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.depositManageStr ===
                      '銀行口座で直接受取（月1回入金）（オプション）' &&
                    isFukuoka
                      ? '銀行口座'
                      : detail.depositManageStr}
                  </TableCell>
                </TableRow>
              )}

              {detail.depositManage === 'NONSELF' && enableShopBank && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    銀行名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.bankName}
                  </TableCell>
                </TableRow>
              )}
              {detail.depositManage === 'NONSELF' && enableShopBank && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    支店名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.bankBranchName}
                  </TableCell>
                </TableRow>
              )}
              {detail.depositManage === 'NONSELF' && enableShopBank && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    口座種別
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.bankAccountTypeStr}
                  </TableCell>
                </TableRow>
              )}
              {detail.depositManage === 'NONSELF' && enableShopBank && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    口座番号
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.bankAccountNumber}
                  </TableCell>
                </TableRow>
              )}
              {detail.depositManage === 'NONSELF' && enableShopBank && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    口座名義
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.bankAccountHolder}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  登録日時
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.createdAt}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  更新日時
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.updatedAt}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TabPanelDetail>

        {/* Optional その他（任意） */}
        <TabPanelDetail value={value} index={1}>
          <Table className={classes.detailTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  {isFukuoka ? '教室概要' : '店舗概要'}
                </TableCell>
                <TableCell
                  className={[classes.tableCellData, classes.breakLine]}
                >
                  {introduction}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  営業時間
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {businessHours}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>定休日</TableCell>
                <TableCell className={classes.tableCellData}>
                  {holiday}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  {isFukuoka ? '平均金額' : '価格帯'}
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.priceRange}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  {isFukuoka ? '最寄り駅' : '最寄駅'}
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {nearestStation}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  アクセス
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {access}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  WebページURL
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.webPage}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  タグ Tag
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  <div>
                    {detail.tags.map(tag => {
                      return <span className={classes.tag}>{tag.tagName}</span>;
                    })}
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>画像</TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.images.map(image => {
                    return (
                      <Card className={classes.userImage}>
                        <CardActionArea>
                          <CardMedia component="img" image={image.image} />
                        </CardActionArea>
                      </Card>
                    );
                  })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>SNS</TableCell>
                <TableCell className={classes.tableCellData}>
                  <div className={classes.margin}>
                    <Grid container spacing={1} alignItems="flex-end">
                      <Grid item>
                        <CardMedia
                          component="img"
                          alt="Facebook"
                          height="24"
                          image="/images/icon_facebook.png"
                          title="Facebook"
                          className={classes.marginBottom12}
                        />
                      </Grid>
                      {detail.snsFacebook && (
                        <Grid item xs={12} sm container>
                          <TableCell className={classes.tableCellData}>
                            {detail.snsFacebook}
                          </TableCell>
                        </Grid>
                      )}
                    </Grid>
                    <Grid container spacing={1} alignItems="flex-end">
                      <Grid item>
                        <CardMedia
                          component="img"
                          alt="Twitter"
                          height="24"
                          image="/images/icon_twitter.png"
                          title="Twitter"
                          className={classes.marginBottom12}
                        />
                      </Grid>
                      {detail.snsTwitter && (
                        <Grid item xs={12} sm container>
                          <TableCell className={classes.tableCellData}>
                            {detail.snsTwitter}
                          </TableCell>
                        </Grid>
                      )}
                    </Grid>
                    <Grid container spacing={1} alignItems="flex-end">
                      <Grid item>
                        <CardMedia
                          component="img"
                          alt="Instagram"
                          height="24"
                          image="/images/icon_instagram.png"
                          title="Instagram"
                          className={classes.marginBottom12}
                        />
                      </Grid>
                      {detail.snsInstagram && (
                        <Grid item xs={12} sm container>
                          <TableCell className={classes.tableCellData}>
                            {detail.snsInstagram}
                          </TableCell>
                        </Grid>
                      )}
                    </Grid>
                  </div>
                </TableCell>
              </TableRow>
              {!isFukuoka && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      座席
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {numberSit}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      禁煙/喫煙
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {smoking}
                    </TableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>駐車場</TableCell>
                <TableCell className={classes.tableCellData}>
                  {parking}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TabPanelDetail>

        {/* Advanced 高度な設定（任意） */}
        <TabPanelDetail value={value} index={2}>
          <Table className={classes.detailTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  店舗詳細表示制限
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.stealthModeStr}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  誰でもごち制限
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.gochiRestrictionStr}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  社食ごちめし金額指定チケット利用の有無
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.shopDetail && detail.shopDetail.allowMenuPriceShashoku
                    ? '利用する'
                    : '利用しない'}
                </TableCell>
              </TableRow>
              {/* <TableRow>
                <TableCell className={classes.tableCellItem}>
                  社食ごちめし現金授受の有無
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.cashAllowed ? '受け付ける' : '受け付けない'}
                </TableCell>
              </TableRow> */}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  差額決済利用可否
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {detail.shopDetail && detail.shopDetail.allowGapPayment
                    ? '可能 （券売機で営業または通販サービス）'
                    : '不可（上記以外）'}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TabPanelDetail>
      </Paper>
    );
  }
);

export default withStyles(styles)(ShopTable);
